import type {
  AutoCompleteSuggestions,
  EmptySearchSuggestions,
  SuggestionRedirections,
} from './interfaces/suggestions';

export interface SuggestionsState {
  isFetching: boolean;
  termQuery?: string;
  redirections?: SuggestionRedirections;
  error?: Error;
}

export const suggestionsInitialState: SuggestionsState = {
  isFetching: false,
};

export interface SearchBarState {
  suggestions: SuggestionsState;
  autoComplete?: AutoCompleteSuggestions;
  emptySearch?: EmptySearchSuggestions;
}

export const searchBarInitialState: SearchBarState = {
  suggestions: suggestionsInitialState,
};
